// extracted by mini-css-extract-plugin
module.exports = {"content":"ModalPolitics_content__1hy6X","modalMainTitle":"ModalPolitics_modalMainTitle__2NnK-","title":"ModalPolitics_title__luzB2","text":"ModalPolitics_text__3hm-o"};